// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dp.theme--light.v-data-table>.v-data-table__wrapper>table>thead>tr>th[data-v-030868f6]{color:#fff;font-size:16px}.dp.theme--light.v-data-table>.v-data-table__wrapper>table>thead>tr>th[data-v-030868f6]:hover,.theme--light.v-icon[data-v-030868f6]{color:#fff}.dp[data-v-030868f6]{color:#00475a;font-weight:bolder}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
